"use strict";

exports.__esModule = true;
exports.DefaultPlaybackPolicyHandler = void 0;
var _PlaybackPolicyHandler = require("../Public/PlaybackPolicyHandler");
var _Session = require("../Public/Session");
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); } /*
 * COPYRIGHT 2022 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */
// DefaultPlaybackPolicyHandler is a default implementation of the PlaybackPolicyHandler if a customer
// implemented policy handler is not provided.
var DefaultPlaybackPolicyHandler = exports.DefaultPlaybackPolicyHandler = /*#__PURE__*/function (_PlaybackPolicyHandle) {
  _inheritsLoose(DefaultPlaybackPolicyHandler, _PlaybackPolicyHandle);
  function DefaultPlaybackPolicyHandler(playbackMode) {
    var _this;
    _this = _PlaybackPolicyHandle.call(this) || this;
    _this.playbackMode = playbackMode;
    return _this;
  }
  var _proto = DefaultPlaybackPolicyHandler.prototype;
  _proto.canStop = function canStop(_playhead, _timeline) {
    switch (this.playbackMode) {
      case _Session.PlaybackMode.LIVE:
      case _Session.PlaybackMode.DVRLIVE:
      case _Session.PlaybackMode.VOD:
      default:
        return true;
    }
  };
  _proto.canPause = function canPause(_playhead, _timeline) {
    switch (this.playbackMode) {
      case _Session.PlaybackMode.LIVE:
        return false;
      case _Session.PlaybackMode.DVRLIVE:
      case _Session.PlaybackMode.VOD:
      default:
        return true;
    }
  };
  _proto.canSkip = function canSkip(_playhead, _timeline, _duration) {
    switch (this.playbackMode) {
      case _Session.PlaybackMode.LIVE:
        return -1;
      case _Session.PlaybackMode.DVRLIVE:
        return 0;
      case _Session.PlaybackMode.VOD:
        return 0;
      default:
        return 0;
    }
  };
  _proto.willSeekTo = function willSeekTo(position, _timeline, playhead) {
    switch (this.playbackMode) {
      case _Session.PlaybackMode.LIVE:
        return playhead;
      case _Session.PlaybackMode.DVRLIVE:
        return position;
      case _Session.PlaybackMode.VOD:
      default:
        return position;
    }
  };
  _proto.canChangeVolume = function canChangeVolume(_mute, _playhead, _timeline) {
    switch (this.playbackMode) {
      case _Session.PlaybackMode.LIVE:
      case _Session.PlaybackMode.DVRLIVE:
      case _Session.PlaybackMode.VOD:
      default:
        return true;
    }
  };
  _proto.canResize = function canResize(_fullScreen, _playhead, _timeline) {
    switch (this.playbackMode) {
      case _Session.PlaybackMode.LIVE:
      case _Session.PlaybackMode.DVRLIVE:
      case _Session.PlaybackMode.VOD:
      default:
        return true;
    }
  };
  _proto.canResizeCreative = function canResizeCreative(_expand, _playhead, _timeline) {
    switch (this.playbackMode) {
      case _Session.PlaybackMode.LIVE:
      case _Session.PlaybackMode.DVRLIVE:
      case _Session.PlaybackMode.VOD:
      default:
        return true;
    }
  };
  _proto.canClickThrough = function canClickThrough(_url, _playhead, _timeline) {
    switch (this.playbackMode) {
      case _Session.PlaybackMode.LIVE:
      case _Session.PlaybackMode.DVRLIVE:
      case _Session.PlaybackMode.VOD:
      default:
        return true;
    }
  };
  _proto.setPlaybackMode = function setPlaybackMode(mode) {
    this.playbackMode = mode;
  };
  _proto.didSkip = function didSkip(_from, _to, _timeline) {
    // This is intentionally left empty as no action is taken for default handler
  };
  _proto.didSeek = function didSeek(_from, _to, _timeline) {
    // This is intentionally left empty as no action is taken for default handler
  };
  return DefaultPlaybackPolicyHandler;
}(_PlaybackPolicyHandler.PlaybackPolicyHandler);